module.exports = __webpack_public_path__ + "static/media/slideSpray.faba736b.gif";